import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { PortalCard } from '../portal';

interface SettingsSectionProps {
  title?: ReactNode;
  description?: ReactNode;
  /** Header-right slot: a count, a status pill or a secondary button. */
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Card every settings page groups its fields in: `p-6 sm:p-8`, `gap-6` body. */
export function SettingsSection({
  title,
  description,
  action,
  children,
  className,
}: SettingsSectionProps) {
  return (
    <PortalCard className={cn('flex flex-col gap-6 p-6 sm:p-8', className)}>
      {title || description || action ? (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
          <div className="flex min-w-0 flex-col text-sm leading-5">
            {title ? <h2 className="font-bold text-white">{title}</h2> : null}
            {description ? (
              <div className="text-seeker-400">{description}</div>
            ) : null}
          </div>
          {action ? (
            <div className="flex shrink-0 flex-wrap items-center gap-3">
              {action}
            </div>
          ) : null}
        </div>
      ) : null}
      <div className="flex flex-col gap-6">{children}</div>
    </PortalCard>
  );
}
